const FREE_EMAIL_DOMAINS = new Set([
  // Google
  "gmail.com",
  "googlemail.com",
  // Microsoft
  "outlook.com",
  "hotmail.com",
  "hotmail.co.uk",
  "hotmail.fr",
  "live.com",
  "live.co.uk",
  "msn.com",
  // Apple
  "icloud.com",
  "me.com",
  "mac.com",
  // Yahoo
  "yahoo.com",
  "yahoo.co.uk",
  "yahoo.fr",
  "yahoo.de",
  "yahoo.es",
  "yahoo.it",
  "yahoo.com.au",
  "yahoo.com.br",
  "yahoo.ca",
  "ymail.com",
  // Proton
  "proton.me",
  "protonmail.com",
  "protonmail.ch",
  "pm.me",
  // Other popular free providers
  "aol.com",
  "aim.com",
  "mail.com",
  "zoho.com",
  "gmx.com",
  "gmx.de",
  "gmx.net",
  "web.de",
  "t-online.de",
  "freenet.de",
  "yandex.com",
  "yandex.ru",
  "mail.ru",
  "inbox.com",
  "fastmail.com",
  "fastmail.fm",
  "hey.com",
  "tutanota.com",
  "tutamail.com",
  "tuta.io",
  // Telecom / ISP providers
  "verizon.net",
  "att.net",
  "bellsouth.net",
  "comcast.net",
  "sbcglobal.net",
  "cox.net",
  "charter.net",
  "earthlink.net",
  "optonline.net",
  "btinternet.com",
  "virginmedia.com",
  "sky.com",
  "ntlworld.com",
  "talktalk.net",
  "orange.fr",
  "free.fr",
  "sfr.fr",
  "laposte.net",
  "wanadoo.fr",
  "bbox.fr",
  "numericable.fr",
]);

export function isBusinessEmail(email: string): boolean {
  const domain = email.split("@")[1]?.toLowerCase();
  if (!domain) return false;
  return !FREE_EMAIL_DOMAINS.has(domain);
}
